<template>
  <AppFormGroup>
    <SubHeading keypath="headings.preferences" />
    <AppField
      preferred-component="dropdown"
      :path-prefix="applicantType"
      path="preferredLanguage"
    />
  </AppFormGroup>
</template>

<script setup lang="ts">
  import {
    AppFormGroup,
    AppField,
  } from "@versatile-credit-apply/components/form"
  import type { FormSectionProps } from "@/pages/apply/application/sections/form-section-api"
  import { useProviderI18n } from "@versatile-credit-apply/sdk"

  const props = defineProps<FormSectionProps>()

  useProviderI18n(() => props.providerKey)
</script>

<i18n lang="yaml" locale="en">
appFields:
  preferredLanguage:
    label: Preferred Language
headings:
  preferences: Preferences

</i18n>
